/** Tokens visuais — configurações loja (marca TNV) */
export const CONFIG_ACCENT = "#F96030";
export const CONFIG_INK = "#1a2035";

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${CONFIG_ACCENT}, #e04a1a)`,
};

export const sectionPanelSx = {
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 2,
  bgcolor: "background.paper",
  overflow: "hidden",
};

export const sectionHeaderSx = {
  px: 3,
  py: 2,
  bgcolor: "grey.50",
  borderBottom: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CONFIG_ACCENT}`,
};

export const stickyFooterSx = {
  position: "sticky" as const,
  bottom: 0,
  zIndex: 2,
  mt: 2,
  px: 3,
  py: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CONFIG_ACCENT}`,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
};

export const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: CONFIG_ACCENT },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    bgcolor: `${CONFIG_ACCENT} !important`,
  },
};

export const infoBannerSx = {
  p: 2,
  borderRadius: 1.5,
  bgcolor: "rgba(249, 96, 48, 0.06)",
  border: "1px solid",
  borderColor: "rgba(249, 96, 48, 0.2)",
};
